import request from '../../utils/request';

// 企业成员树
export function getOrganization(params,Authorization,isLoading) {
  return request({
    url: '/api/organization/structure',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },isLoading)
}